import { useFormikContext } from 'formik';
import { Paper, Stack, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Sidebar from '../Sidebar';
import { useResponsive } from '@/hooks';
import { Contact as IContact } from '@/types/quote';

const Contact = () => {
  const { isMobile } = useResponsive();
  const { values, handleChange } = useFormikContext<{ contact: IContact }>();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 9 }}>
        <Stack spacing={2} flex={1}>
          <Paper
            sx={{
              padding: 3,
            }}
          >
            <Stack spacing={2} flex={1}>
              <TextField
                name="contact.name"
                label="Nombre"
                size="small"
                value={values.contact?.name}
                onChange={handleChange}
              />
              <Stack spacing={2} direction={'row'}>
                <TextField
                  name="contact.phone"
                  label="Teléfono"
                  size="small"
                  fullWidth
                  value={values.contact?.phone}
                  onChange={handleChange}
                />
                <TextField
                  name="contact.email"
                  label="Correo"
                  size="small"
                  fullWidth
                  value={values.contact?.email}
                  onChange={handleChange}
                />
              </Stack>
              <TextField
                name="contact.message"
                label="Comentarios"
                multiline
                rows={3}
                value={values.contact?.message}
                onChange={handleChange}
              />
            </Stack>
          </Paper>
        </Stack>
      </Grid>

      {!isMobile ? (
        <Grid size={{ xs: 12, md: 3 }}>
          <Sidebar />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default Contact;
